import type { DxReportOrthopulseStatus } from '../../../patient-files/actions/dx-report/types';

export type OrthopulseLevel = 'mandatory' | 'recommended';

// Dx report status wins when present ('not_needed' leaves the toggle off and
// unbadged); Monday's legacy recommendation is the fallback only when absent.
export function resolveOrthopulseLevel(
    dxReportStatus: DxReportOrthopulseStatus | null,
    mondayRecommendation: string | null
): OrthopulseLevel | null {
    if (dxReportStatus !== null) {
        return dxReportStatus === 'mandatory' || dxReportStatus === 'recommended'
            ? dxReportStatus
            : null;
    }
    const normalized = (mondayRecommendation ?? '').trim().toLowerCase();
    if (normalized === 'required' || normalized === 'mandatory') return 'mandatory';
    if (normalized === 'recommended') return 'recommended';
    return null;
}
